'use client'
import { useEffect } from 'react'
import $ from 'jquery'
import { usePathname } from 'next/navigation'

const CustomScript = () => {
  const pathname = usePathname()
  useEffect(() => {
    if (pathname?.includes('-sku-') || pathname?.includes('complete-jewel')) {
      window.scrollTo({ top: 0, behavior: 'instant' })
    }
  }, [pathname])
  useEffect(() => {
    let homeAnimTimeout: ReturnType<typeof setTimeout> | undefined
    let onHomeAnimScroll: (() => void) | undefined

    const onFixedHeaderScroll = () => {
      const sticky = document.getElementById('fixed-top')
      if (!sticky) return

      if (window.scrollY >= 27) {
        sticky.classList.add('fixed-header')
      } else {
        sticky.classList.remove('fixed-header')
      }
    }
    window.addEventListener('scroll', onFixedHeaderScroll, { passive: true })

    // Advance Filter toggle
    $(document).on(
      'click',
      '.advance-filter-listing-col .advance-filter-listing-bar-title',
      function () {
        $('.advance-filter-listing').toggleClass('active')
        $(this).toggleClass('active')
        // if ($('.advance-filter-listing').hasClass('active')) {
        //     $('.advance-filter-listing-bar-title span').text('Close');
        // } else {
        //     $('.advance-filter-listing-bar-title span').text('Advance Filters');
        // }
      }
    )

    // if (typeof window !== 'undefined' && typeof document !== 'undefined') return
    const ImgUrl = 'https://hjl.s3.eu-west-2.amazonaws.com/assets/images/tooltips/'
    function DiamondBoxToggle() {
      // Diamond listing details open
      $(document).on('click', '.table-list-title', function (e) {
        e.stopImmediatePropagation()
        // if ($(this).closest('.repeat-item-link').hasClass('active')) {
        //   $('.repeat-item-link.active').removeClass('active');
        // } else {
        //   $(this).closest('.repeat-item-link').addClass('active');
        // }
        $('.table-list-title').not(this).closest('.repeat-item-link').removeClass('active')
        $(this).closest('.repeat-item-link').toggleClass('active')
      })
    }

    function FixedRoot() {
      // body fixed when sidebar open
      $(document).on('click', '.navbar-toggler', function () {
        $('.navbar-collapse').addClass('show')
        if ($('body').hasClass('body-fixed')) {
          $('body.body-fixed').removeClass('body-fixed')
        } else {
          $('body').addClass('body-fixed')
        }
      })

      $(document).on('click', '.mobile-menu-overlay', function () {
        $('body.body-fixed').removeClass('body-fixed')
        $('#navbarNavDropdown').removeClass('show')
        $('.megamenu.show').removeClass('show')
      })
      $(document).on('click', '.shop-button', function () {
        $('body.body-fixed').removeClass('body-fixed')
        $('#navbarNavDropdown').removeClass('show')
        $('.megamenu.show').removeClass('show')
      })

      $(document).on('click', '.navbar-toggler.btn-close', function () {
        $('.navbar-collapse').removeClass('show')
        $('body.body-fixed').removeClass('body-fixed')
      })
      $(document).on('click', '.menu-back', function () {
        $('.megamenu.show').removeClass('show')
      })
      $(document).on('click', '.subnav-bar-item', function () {
        $('body.body-fixed').removeClass('body-fixed')
        $('#navbarNavDropdown').removeClass('show')
      })
      $(document).on('click', '.single-link', function () {
        $('body.body-fixed').removeClass('body-fixed')
        $('#navbarNavDropdown').removeClass('show')
      })
      $(document).on('click', '.mobile-menu-footer-block li a', function () {
        $('body.body-fixed').removeClass('body-fixed')
        $('#navbarNavDropdown').removeClass('show')
      })
    }

    function SearchBar() {
      // Search bar toggle
      $(document).on('click', '.search-bar .search-bar-icon', function () {
        // if ($('#search-bar-box').hasClass('active')) {
        //   $('#search-bar-box').removeClass('active');
        // } else {
        //   $('#search-bar-box').addClass('active');
        // }
        $('#search-bar-box').toggleClass('active')
      })
      $(document).on('click', function (e: any) {
        var CloseSearchBox = $('.search-bar')
        if (!CloseSearchBox.is(e.target) && !CloseSearchBox.has(e.target).length) {
          $('#search-bar-box').removeClass('active')
          $('#search-bar-mobile').removeClass('active')
          $('#sidebar-search-mobile').removeClass('active')
          $('.search-bar .feather-close').removeClass('active')
          $('.search-bar .feather-search').addClass('active')
          //$('#mainSearchBox').attr('value', '');
          //$('#sidebarSearchBox').attr('value', '');
        }
      })
      $(document).on('click', '.search-bar .feather-close', function () {
        // $(".search-bar-form input").val(null);
        // $('#mainSearchBox').attr('value', '');
        $('.search-bar .feather-search').addClass('active')
        $('#search-bar-box').toggleClass('active')
        $('#search-bar-mobile').removeClass('active')
        $('#sidebar-search-mobile').removeClass('active')
        $('.search-bar .feather-close').removeClass('active')
      })

      $(document).on('keyup', '#mainSearchBox', function () {
        if ($(this).val().length > 0) {
          $('.search-bar .feather-close').addClass('active')
          $('.search-bar .feather-search').removeClass('active')
          $('#search-bar-mobile').addClass('active')
        } else {
          $('.search-bar .feather-search').addClass('active')
          $('.search-bar .feather-close').removeClass('active')
          $('#search-bar-mobile').removeClass('active')
        }
      })
      $(document).on('keyup', '#sidebarSearchBox', function (e) {
        if ($(this).val().length > 0) {
          $('#sidebar-search-mobile .feather-close').addClass('active')
          $('#sidebar-search-mobile .feather-search').removeClass('active')
          $('#sidebar-search-mobile').addClass('active')
        } else {
          $('#sidebar-search-mobile .feather-search').addClass('active')
          $('#sidebar-search-mobile .feather-close').removeClass('active')
          $('#sidebar-search-mobile').removeClass('active')
        }
        if (e.key === 'Enter') {
          e.preventDefault()
          $('#navbarNavDropdown').removeClass('show')
          $('body.body-fixed').removeClass('body-fixed')
        }
      })
    }

    function FilterPopup() {
      // mobile filter popup add class
      $(document).on('click', '.filter-listing-bar-title', function (e) {
        if ($('.filter-listing-bar-title').hasClass('active')) {
          $('.filter-listing-bar-title').removeClass('active')
          $('body').removeClass('filter-overlay')
          $(this).addClass('active')
        } else {
          $(this).addClass('active')
          $('body').addClass('filter-overlay')
        }
        e.stopPropagation()
      })

      $(document).on('click', function (e: any) {
        var FilBox = $('.filter-listing-icons')
        if (!FilBox.is(e.target) && !FilBox.has(e.target).length) {
          $('.filter-listing-bar-title').removeClass('active')
        }
      })

      $(document).on('click', '.filter-listing-bar-title.active', function () {
        $('.filter-listing-bar-title.active').removeClass('active')
      })
      $(document).on('click', '.mobile-filter-close .btn-close', function () {
        $('.filter-listing-bar-title.active').removeClass('active')
        $('body').removeClass('filter-overlay')
      })
    }

    function FilterToggle() {
      $(document).on('click', '.mobile-filter .filters-toggle', function () {
        $('.mobile-filter').addClass('active')
        $('.mobile-filter-overlay').addClass('active')
        $('body').addClass('body-fixed')
      })
      $(document).on('click', '.mobile-filter .mobile-filter-close', function () {
        $('.mobile-filter').removeClass('active')
        $('.mobile-filter-overlay').removeClass('active')
        $('body').removeClass('body-fixed')
      })
      $(document).on('click', '.mobile-filter-overlay', function () {
        $('.mobile-filter').removeClass('active')
        $('.mobile-filter-overlay').removeClass('active')
        $('body').removeClass('body-fixed')
      })
    }

    function HomePageAnimation() {
      homeAnimTimeout = setTimeout(() => {
        const section = document.querySelector('.category-product-section')
        if (!section) return

        const sectionTop = section.getBoundingClientRect().top + window.pageYOffset

        onHomeAnimScroll = () => {
          if (window.scrollY > sectionTop) {
            document
              .querySelectorAll('.category-product-img')
              .forEach((el) => el.classList.add('show-animation'))
            document
              .querySelectorAll('.scroll-title-name')
              .forEach((el) => el.classList.add('show-animation'))
            if (onHomeAnimScroll) {
              window.removeEventListener('scroll', onHomeAnimScroll)
              onHomeAnimScroll = undefined
            }
          }
        }

        window.addEventListener('scroll', onHomeAnimScroll, { passive: true })
      }, 300)
    }

    function BacktoTopScroll() {
      // Scroll to top
      $(document).on('click', '.top-scroll', function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
      })

      $(window).on('scroll.backToTop', function () {
        const scrollPos = window.scrollY || window.pageYOffset
        const docHeight = document.documentElement.scrollHeight
        const winHeight = window.innerHeight
        const scrollPercent = scrollPos / (docHeight - winHeight || 1)
        const scrollPercentRounded = Math.round(scrollPercent * 100)
        if (scrollPos <= 0) {
          $('.top-scroll').css('opacity', '0')
        } else {
          $('.top-scroll').css('opacity', '1')
          $('#top-scroll-bg').css('height', scrollPercentRounded + '%')
        }
      })
    }

    // Mobile footer menu
    function MobileFooterMenu() {
      if (typeof window != 'undefined' && window.innerWidth < 768) {
        $(document).on('click', '.footer-link-title', function () {
          if ($(this).parents('.footer-link').hasClass('active')) {
            $(this)
              .parents('.footer-link')
              .removeClass('active')
              .find('.footer-link-list')
              .slideUp()
          } else {
            $('.footer-top').find('.footer-link-list').slideUp()
            $('.footer-top').find('.footer-link.active').removeClass('active')
            $(this).parents('.footer-link').addClass('active').find('.footer-link-list').slideDown()
          }
          return
        })
        $(document).on('click', '.footer-link-list li', function () {
          $(this).parents('.footer-link').removeClass('active').find('.footer-link-list').slideUp()
          return
        })

        $(window).on('scroll.diamondListingTable', function () {
          const scrollPos = window.scrollY || window.pageYOffset
          if (scrollPos > 275) {
            $('.diamond-listing-table').addClass('active')
          } else {
            $('.diamond-listing-table').removeClass('active')
          }
        })
      }
    }

    function MinicartRemove() {
      $(document).on('mouseover', '.cart-bar', function () {
        $('.cart-bar').addClass('active')
      })
      $(document).on('mouseleave', '.cart-bar', function () {
        $('.cart-bar').removeClass('active')
      })

      $(document).on('click', '.btn-minicart', function (e) {
        var CartLink = $('.cart-bar')
        CartLink.removeClass('active')
      })
    }

    function DiamondShapeTab() {
      $(document).on('click', '.carat-grade-list li', function () {
        var imgpath = $(this).attr('data-number')
        // var ImgUrl = 'https://hjl.s3.eu-west-2.amazonaws.com/assets/images/tooltips/';
        //var shortdesc = $(this).attr('data-text');
        var dataheading = $(this).attr('data-cap')

        $('.carat-grade-list li.active').removeClass('active')
        $(this).addClass('active')
        $('.carat-grade-item .carat-grade-img').html(
          '<img src=' + ImgUrl + 'carat/carat_' + imgpath + '.png alt="carat">'
        )
        //$('.carat-grade-item .grade-desc').html('<small>'+shortdesc+'</small>');
        $('.carat-grade-item .grade-title').html('' + dataheading + '')
      })

      $(document).on('click', '.currency-selector li', function () {
        var DataSymbol = $(this).attr('data-symbol')
        var DataName = $(this).attr('data-name')
        $('.currency-symbol').html('' + DataSymbol + '')
        $('.selected-currency-name').html('' + DataName + '')
      })

      $(document).on('click', '.color-grade-list li', function () {
        var imgpath = $(this).attr('data-number')
        // var ImgUrl = 'https://hjl.s3.eu-west-2.amazonaws.com/assets/images/tooltips/';
        var shortdesc = $(this).attr('data-text')
        var dataheading = $(this).attr('data-cap')

        $('.color-grade-list li.active').removeClass('active')
        $(this).addClass('active')
        $('.color-grade-item .color-grade-img').html(
          '<img src=' + ImgUrl + 'colour/colour_' + imgpath + '.png alt="colour">'
        )
        $('.color-grade-item .grade-desc').html('<small>' + shortdesc + '</small>')
        $('.color-grade-item .grade-title').html('' + dataheading + '')
      })

      $(document).on('click', '.clarity-grade-list li', function () {
        var imgpath = $(this).attr('data-number')
        // var ImgUrl = 'https://hjl.s3.eu-west-2.amazonaws.com/assets/images/tooltips/';
        var shortdesc = $(this).attr('data-text')
        var dataheading = $(this).attr('data-cap')

        $('.clarity-grade-list li.active').removeClass('active')
        $(this).addClass('active')
        $('.clarity-grade-item .clarity-grade-img').html(
          '<img src=' + ImgUrl + 'clarity/clarity_' + imgpath + '.png alt="clarity">'
        )
        $('.clarity-grade-item .grade-desc').html('<small>' + shortdesc + '</small>')
        $('.clarity-grade-item .grade-title').html('' + dataheading + '')
      })

      $(document).on('click', '.cut-grade-list li', function () {
        var imgpath = $(this).attr('data-number')
        // var ImgUrl = 'https://hjl.s3.eu-west-2.amazonaws.com/assets/images/tooltips/';
        var shortdesc = $(this).attr('data-text')
        var dataheading = $(this).attr('data-cap')

        $('.cut-grade-list li.active').removeClass('active')
        $(this).addClass('active')
        $('.cut-grade-item .cut-grade-img').html(
          '<img src=' + ImgUrl + 'cut/cut_' + imgpath + '.png alt="cut">'
        )
        $('.cut-grade-item .grade-desc').html('<small>' + shortdesc + '</small>')
        $('.cut-grade-item .grade-title').html('' + dataheading + '')
      })
    }

    function DiamondListingTab() {
      $('.list-view-tab .nav-link').on('click', function () {
        $('#list-view-tab').addClass('active')
        $('#grid-view-tab').removeClass('active')
      })

      // $('#product-grid-view').addClass('active')
      $('.grid-view-tab .nav-link').on('click', function () {
        $('#grid-view-tab').addClass('active')
        $('#list-view-tab').removeClass('active')
      })
    }

    function EducationHover() {
      setTimeout(function () {
        var EducationListing = $('.education-listing')
        var EducationListingCo = $('#education-listing-container')
        EducationListingCo.mousemove(function (e) {
          var ivalueX = (e.pageX * -1) / 30 / 4
          var ivalueY = (e.pageY * -1) / 30 / 4
          EducationListing.css('transform', 'translate3d(' + ivalueX + 'px,' + ivalueY + 'px, 0)')
        })
        EducationListingCo.mouseleave(function (e) {
          console.log('ok')
          // EducationListing.css('transform', 'translate3d('+0+'px,'+0+'px, 0)');
        })
      }, 300)
    }

    function EducationMenuActive() {
      if ($('.breadcrumb-item > a:contains("Education")').length > 0) {
        setTimeout(function () {
          $('.nav-item_4 .nav-link').addClass('active')
        }, 3000)
      }
      $('.nav-item_4 .nav-link').removeClass('active')
      $(document).on('click', '', function (e) {
        if ($('.breadcrumb-item > a:contains("Education")').length > 0) {
          setTimeout(function () {
            $('.nav-item_4 .nav-link').addClass('active')
          }, 1500)
        } else {
          $('.nav-item_4 .nav-link').removeClass('active')
        }
      })
    }

    $(document).ready(function () {
      DiamondBoxToggle()
      FixedRoot()
      SearchBar()
      FilterPopup()
      FilterToggle()
      HomePageAnimation()
      BacktoTopScroll()
      MobileFooterMenu()
      MinicartRemove()
      DiamondShapeTab()
      EducationHover()
      EducationMenuActive()
      DiamondListingTab()
      if (typeof window !== 'undefined' && window.innerWidth > 768) {
        $(document).on('mouseover', '.navbar-nav .nav-item', function () {
          $(this).addClass('active')
        })
        $(document).on('mouseleave', '.navbar-nav .nav-item', function () {
          $('.navbar-nav .nav-item.active').removeClass('active')
        })
        $(document).on('click', '.subnav-bar-menu li a', function () {
          $('.navbar-nav .nav-item.active').removeClass('active')
          $('.navbar-nav .nav-item').removeClass('active')
        })

        // Add class in product listing page
        $(document).on('mouseover', '.product-listing-box', function () {
          $(this).addClass('show')
        })
        $(document).on('mouseleave', '.product-listing-box', function () {
          $('.product-listing-box.show').removeClass('show')
        })
      }
    })

    return () => {
      window.removeEventListener('scroll', onFixedHeaderScroll)
      if (homeAnimTimeout) clearTimeout(homeAnimTimeout)
      if (onHomeAnimScroll) window.removeEventListener('scroll', onHomeAnimScroll)
      $(window).off('scroll.backToTop')
      $(window).off('scroll.diamondListingTable')
    }
  }, [])
  return null
}

export default CustomScript
